import React from "react";
import { Link, useLocation } from "react-router-dom";
import {
  FaHome,
  FaClipboardList,
  FaShoppingCart,
  FaUser,
  FaSpinner,
  FaSearch,
} from "react-icons/fa";

import homeIcon from "../assets/img/icons/home.png";
import searchIcon from "../assets/img/icons/order_list.png";
import inProgressIcon from "../assets/img/icons/4.png";
import newOrderIcon from "../assets/img/icons/5.png";
import filterIcon from "../assets/img/icons/2.png";
import completedIcon from "../assets/img/icons/deliveri.png";
import createOrderIcon from "../assets/img/icons/new_order.png";

export const Footer = () => {
  const userRole = localStorage.getItem("userRole"); // Get the user role from localStorage
  const selectedMfr = JSON.parse(localStorage.getItem("selectedMfr"));
  const { pathname } = useLocation();

  // Highlights the tab for the current screen
  const linkClass = (to) =>
    pathname === to || pathname.startsWith(`${to}/`)
      ? "footer-link active"
      : "footer-link";

  return (
    <div>
      <div className="footer">
        <div className="footer-container">
          {/* Home Icon */}
          <div className="footer-item">
            <Link to="/home" className={linkClass("/home")}>
              <img src={homeIcon} className="icon" alt="Home" />
              <span>Home</span>
            </Link>
          </div>

          <div className="footer-item">
            {userRole === "MFR" ||
            userRole === "SUPERADMIN" ||
            userRole === "COMFR" ? (
              <Link to="/order-list" className={linkClass("/order-list")}>
                <img src={searchIcon} className="icon" alt="Home" />
                <span>Search Order</span>
              </Link>
            ) : userRole === "Customer" ? (
              <Link to="/my-orders" className={linkClass("/my-orders")}>
                <img src={searchIcon} className="icon" alt="My Orders" />
                <span>My Orders</span>
              </Link>
            ) : (
              <Link to="/status/inProcess" className={linkClass("/status/inProcess")}>
                <img src={inProgressIcon} className="icon" alt="Home" />
                <span>In Progress</span>
              </Link>
            )}
          </div>

          {/* Customers already have Home, My Orders and Create Order */}
          {userRole !== "Customer" && (
            <div className="footer-item">
              {userRole === "Karigar" || userRole === "SEMIMFR" ? (
                <Link to="/status/Issued" className={linkClass("/status/Issued")}>
                  {" "}
                  {/* Replace with the correct Admin URL */}
                  <img src={newOrderIcon} className="icon" alt="Home" />
                  <span>New Order</span>
                </Link>
              ) : (
                <Link to="/filter" className={linkClass("/filter")}>
                  <img src={filterIcon} className="icon" alt="Home" />
                  <span>Filter</span>
                </Link>
              )}
            </div>
          )}

          {/* Karigar-only "Completed" tab. Rendered only when it has content,
              so other roles don't get an empty slot breaking the spacing. */}
          {userRole === "Karigar" && (
            <div className="footer-item">
              <Link to="/status/ready" className={linkClass("/status/ready")}>
                {" "}
                {/* Replace with the correct Admin URL */}
                {/* <FaUser className="icon" /> */}
                <img src={completedIcon} className="icon" alt="Home" />
                <span>Completed</span>
              </Link>
            </div>
          )}

          <div className="footer-item">
            <Link to="/order" className={linkClass("/order")}>
              <div className="footer-fab">
                <img src={createOrderIcon} alt="Create Order" />
              </div>
              <span>Create Order</span>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
